"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_OPTIONS = void 0;
const role_1 = require("./role");
exports.ROLE_OPTIONS = [
    { value: role_1.Role.User, label: 'User', checked: false },
    { value: role_1.Role.UserAdministrator, label: 'User Administrator', checked: false },
    { value: role_1.Role.CommunityTournamentCreator, label: 'Community Tournament Creator', checked: false },
    { value: role_1.Role.ExternalDistributor, label: 'External Distributor', checked: false },
    { value: role_1.Role.TournamentAdministrator, label: 'Tournament Administrator', checked: false },
    { value: role_1.Role.TournamentSponsoredCreator, label: 'Can create reward eligible tournaments?', checked: false },
    { value: role_1.Role.MatchAdministrator, label: 'Match Administrator', checked: false },
    { value: role_1.Role.GameAdministrator, label: 'Game Administrator', checked: false },
    { value: role_1.Role.TournamentCreator, label: 'Tournament Creator', checked: false },
    { value: role_1.Role.PaymentAdministrator, label: 'Payment Administrator', checked: false },
    { value: role_1.Role.AffiliateProgramAdmin, label: 'Affiliate Program Administrator', checked: false },
    { value: role_1.Role.AffiliateProgramOwner, label: 'Affiliate Program Owner', checked: false },
];
//# sourceMappingURL=role-options.js.map